import { render, staticRenderFns } from "./AddResearch.vue?vue&type=template&id=085d6d61&"
import script from "./AddResearch.vue?vue&type=script&lang=js&"
export * from "./AddResearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports